const STABLE_SCORECARD_CONTRACTS = [
  "games",
  "hands",
  "customizable",
  "gamePlayedBy",
  "gameEnds",
  "vueFileToLoad",
];

const SCORECARD_AUTHORING_PROFILES = {
  "FiveCrowns.vue": {
    family: "fixedRoundRunningTotal",
    archetype: "runningTotal",
    defaultImplementation: "shared-family",
    primaryExemplar: "FiveCrowns.vue",
    expectedLifecycleModel: "round-based",
    persistenceModel: {
      hands: "one entry per round",
      games: "completed game summaries",
    },
    resumeModel: "fixed-grid partial round restore",
    recommendedHelpers: [
      "resolveScorecardSession",
      "loadPartialGameHands",
      "buildCompletedGamePayload",
      "buildWinMessage",
    ],
    recommendedComposables: ["scorecardShared.js"],
    stableContracts: STABLE_SCORECARD_CONTRACTS,
  },
  "GenericScoreCard.vue": {
    family: "openEndedRunningTotal",
    archetype: "runningTotal",
    defaultImplementation: "shared-family",
    primaryExemplar: "GenericScoreCard.vue",
    expectedLifecycleModel: "round-based",
    persistenceModel: {
      hands: "one entry per round",
      games: "completed game summaries",
    },
    resumeModel: "running-grid partial round restore",
    recommendedHelpers: [
      "resolveScorecardSession",
      "loadPartialGameHands",
      "buildCompletedGamePayload",
      "buildWinMessage",
    ],
    recommendedComposables: ["scorecardShared.js"],
    stableContracts: STABLE_SCORECARD_CONTRACTS,
  },
  "YahtzeeScoreCard.vue": {
    family: "fixedRoundRunningTotal",
    archetype: "runningTotal",
    defaultImplementation: "shared-family",
    primaryExemplar: "FiveCrowns.vue",
    expectedLifecycleModel: "fixed-category score grid with per-player turn entry",
    persistenceModel: {
      hands: "one saved category row per game, updated as player cells are filled",
      games: "completed game summaries",
    },
    resumeModel: "rebuild category grid from saved category rows",
    recommendedHelpers: [
      "resolveScorecardSession",
      "buildCompletedGamePayload",
      "buildWinMessage",
      "useSortedGames",
    ],
    recommendedComposables: ["scorecardShared.js"],
    stableContracts: STABLE_SCORECARD_CONTRACTS,
  },
  "HandAndFoot.vue": {
    family: "categoryBasedRoundScorer",
    archetype: "categoryRoundScorer",
    defaultImplementation: "shared-family",
    primaryExemplar: "HandAndFoot.vue",
    expectedLifecycleModel: "round-based",
    persistenceModel: {
      hands: "one entry per round with derived totals",
      games: "completed game summaries",
    },
    resumeModel: "rebuild totals from saved round totals",
    recommendedHelpers: [
      "buildCompletedGamePayload",
      "getCategoryPrintLayout",
    ],
    recommendedComposables: [
      "useCategoryScorecardLifecycle.js",
      "useCategoryScorecardDialogs.js",
    ],
    stableContracts: STABLE_SCORECARD_CONTRACTS,
  },
  "CanastaAmerican.vue": {
    family: "categoryBasedRoundScorer",
    archetype: "categoryRoundScorer",
    defaultImplementation: "shared-family",
    primaryExemplar: "CanastaAmerican.vue",
    expectedLifecycleModel: "round-based",
    persistenceModel: {
      hands: "one entry per round with derived totals",
      games: "completed game summaries",
    },
    resumeModel: "rebuild totals from saved round totals",
    recommendedHelpers: [
      "buildCompletedGamePayload",
      "getCategoryPrintLayout",
    ],
    recommendedComposables: [
      "useCategoryScorecardLifecycle.js",
      "useCategoryScorecardDialogs.js",
    ],
    stableContracts: STABLE_SCORECARD_CONTRACTS,
  },
  "HeartsScoreCard.vue": {
    family: "categoryBasedRoundScorer",
    archetype: "categoryRoundScorer",
    defaultImplementation: "shared-family",
    primaryExemplar: "HeartsScoreCard.vue",
    expectedLifecycleModel: "hand-based penalty scorer with derived totals",
    persistenceModel: {
      hands: "one entry per hand with derived penalty totals and saved hearts detail",
      games: "completed game summaries",
    },
    resumeModel: "rebuild totals from saved hand penalties and saved per-hand detail",
    recommendedHelpers: [
      "buildCompletedGamePayload",
      "getCategoryPrintLayout",
    ],
    recommendedComposables: [
      "useCategoryScorecardLifecycle.js",
      "useCategoryScorecardDialogs.js",
    ],
    stableContracts: STABLE_SCORECARD_CONTRACTS,
  },
  "GinRummyScoreCard.vue": {
    family: "categoryBasedRoundScorer",
    archetype: "categoryRoundScorer",
    defaultImplementation: "shared-family",
    primaryExemplar: "HeartsScoreCard.vue",
    expectedLifecycleModel: "hand-based deadwood scorer with derived totals and end-game bonuses",
    persistenceModel: {
      hands: "one entry per hand with derived hand points and saved gin-rummy detail",
      games: "completed game summaries",
    },
    resumeModel: "rebuild totals from saved hand scores and saved hand detail",
    recommendedHelpers: [
      "buildCompletedGamePayload",
      "getCategoryPrintLayout",
    ],
    recommendedComposables: [
      "useCategoryScorecardLifecycle.js",
      "useCategoryScorecardDialogs.js",
    ],
    stableContracts: STABLE_SCORECARD_CONTRACTS,
  },
  "Pinochle.vue": {
    family: "bespokePlugin",
    archetype: "contractScorer",
    defaultImplementation: "bespoke",
    primaryExemplar: "FiveHundred.vue",
    expectedLifecycleModel: "round-based with contract workflow",
    persistenceModel: {
      hands: "one entry per contract-scored hand",
      games: "completed game summaries",
    },
    resumeModel: "rebuild contract state from saved hands",
    recommendedHelpers: [
      "buildCompletedGamePayload",
      "findGameAndHands",
      "useSortedGames",
    ],
    recommendedComposables: [],
    stableContracts: STABLE_SCORECARD_CONTRACTS,
  },
  "FarkleScoreCard.vue": {
    family: "bespokePlugin",
    archetype: "eventDrivenTurnScorer",
    defaultImplementation: "bespoke",
    primaryExemplar: "FarkleScoreCard.vue",
    expectedLifecycleModel: "turn-based",
    persistenceModel: {
      hands: "rolling live state per game",
      games: "completed game summaries",
    },
    resumeModel: "restore rolling live turn state",
    recommendedHelpers: ["buildCompletedGamePayload", "buildWinMessage"],
    recommendedComposables: [],
    stableContracts: STABLE_SCORECARD_CONTRACTS,
  },
  "FiveHundred.vue": {
    family: "bespokePlugin",
    archetype: "contractScorer",
    defaultImplementation: "bespoke",
    primaryExemplar: "FiveHundred.vue",
    expectedLifecycleModel: "round-based with contract workflow",
    persistenceModel: {
      hands: "one entry per contract-scored round",
      games: "completed game summaries",
    },
    resumeModel: "rebuild contract state from saved rounds",
    recommendedHelpers: ["buildCompletedGamePayload", "buildWinMessage"],
    recommendedComposables: [],
    stableContracts: STABLE_SCORECARD_CONTRACTS,
  },
};

function resolveScorecardAuthoringProfile(vueFileToLoad) {
  if (!vueFileToLoad) {
    return null;
  }

  return SCORECARD_AUTHORING_PROFILES[vueFileToLoad] ?? null;
}

function validateScorecardAuthoringProfile(profile) {
  const missingFields = [];

  if (!profile) {
    return {
      isReady: false,
      missingFields: ["profile"],
      stableContracts: [...STABLE_SCORECARD_CONTRACTS],
    };
  }

  if (!profile.family) {
    missingFields.push("family");
  }

  if (!profile.primaryExemplar) {
    missingFields.push("primaryExemplar");
  }

  if (!profile.expectedLifecycleModel) {
    missingFields.push("expectedLifecycleModel");
  }

  if (!profile.resumeModel) {
    missingFields.push("resumeModel");
  }

  if (!profile.persistenceModel?.hands) {
    missingFields.push("persistenceModel.hands");
  }

  if (!profile.persistenceModel?.games) {
    missingFields.push("persistenceModel.games");
  }

  if (!Array.isArray(profile.recommendedHelpers)) {
    missingFields.push("recommendedHelpers");
  }

  if (!Array.isArray(profile.recommendedComposables)) {
    missingFields.push("recommendedComposables");
  }

  const stableContracts = Array.isArray(profile.stableContracts)
    ? profile.stableContracts
    : [];
  const missingStableContracts = STABLE_SCORECARD_CONTRACTS.filter(
    (contract) => !stableContracts.includes(contract)
  );

  missingStableContracts.forEach((contract) =>
    missingFields.push(`stableContracts.${contract}`)
  );

  return {
    isReady: missingFields.length === 0,
    missingFields,
    stableContracts: [...STABLE_SCORECARD_CONTRACTS],
  };
}

function buildScorecardAuthoringReadiness(vueFileToLoad) {
  const profile = resolveScorecardAuthoringProfile(vueFileToLoad);
  const validation = validateScorecardAuthoringProfile(profile);

  return {
    vueFileToLoad,
    profile,
    ...validation,
  };
}

export {
  buildScorecardAuthoringReadiness,
  resolveScorecardAuthoringProfile,
  SCORECARD_AUTHORING_PROFILES,
  STABLE_SCORECARD_CONTRACTS,
  validateScorecardAuthoringProfile,
};
